// Display helpers for a participant's booking state. The backend signals the
// possible next steps through hypermedia links ("release", "cancel"), so an open
// request is recognised by its release link rather than by a status string.

export const DELETED_STATUS = "GELOESCHT";

// Volunteers are listed alongside participants but are maintained in the event settings.
const VOLUNTEER_STATUSES = ["ORGANISATOR", "LEHRTEAM", "BUSFAHRER"];

export function findLink(participant, rel) {
  return participant?.links?.find((link) => link.rel === rel) ?? null;
}

export function needsRelease(participant) {
  return findLink(participant, "release") !== null;
}

export function isDeleted(participant) {
  return participant?.status === DELETED_STATUS;
}

export function isVolunteer(participant) {
  return VOLUNTEER_STATUSES.includes(participant?.status);
}

function humanize(status) {
  if (!status) {
    return "Unbekannt";
  }
  const words = String(status).toLowerCase().replace(/_/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/**
 * Returns the label and tone used by the status pill.
 * tone is one of "open" | "ok" | "muted".
 */
export function participantStatus(participant) {
  if (isDeleted(participant)) {
    return { label: "Gelöscht", tone: "muted" };
  }
  if (needsRelease(participant)) {
    return { label: "Freigabe offen", tone: "open" };
  }
  return { label: humanize(participant?.status), tone: "ok" };
}

// The member flag is a boolean, but may still be stored as "true"/"false" or, in older
// data, as "Ja"/"Nein". Anything else is unknown.
const MEMBER_VALUES = [true, "true", "Ja"];
const GUEST_VALUES = [false, "false", "Nein"];

export function isMember(participant) {
  return MEMBER_VALUES.includes(participant?.member);
}

export function isGuest(participant) {
  return GUEST_VALUES.includes(participant?.member);
}

export function initials(firstname, lastname) {
  return [firstname, lastname]
    .map((part) => (part ?? "").trim().charAt(0))
    .join("")
    .toUpperCase();
}
